interface GetPortalAuthLinkProps {
  successUrl: string;
  portalId: string;
  authTokenUrl: string;
  nimbusDomain: string;
}

export const getPortalAuthLink = ({
  successUrl,
  portalId,
  authTokenUrl,
  nimbusDomain,
}: GetPortalAuthLinkProps): string => {
  if (successUrl.indexOf(nimbusDomain) !== -1) {
    return successUrl;
  }
  return `${authTokenUrl}/${portalId}?success=${encodeURIComponent(successUrl)}`;
};
